<template>
  <app-custom-dialog
    v-model="dialog"
    title="clock_in"
    title-icon="fal fa-sign-in-alt"
    width="460"
    :footer="false"
  >
    <div slot="activator">
      <!-- Cash drawer picker if store has configured drawers -->
      <TextSelect
        v-if="availableDrawers.length > 0"
        v-model="cashDrawerId"
        :items="availableDrawers"
        text="name"
        itemValue="id"
        :returnObject="false"
        :placeholder="true"
        label="select_cash_drawer"
        class="mb-3"
      />

      <div class="text-body-2 mb-3">
        {{ $t("opening_cash") }}
      </div>
      <ClockInNumpad
        v-model="openingCash"
        :loading="loading"
        :disabled="loading"
        button-text="clock_in"
        @submit="submitClockIn"
      />
    </div>
  </app-custom-dialog>
</template>

<script>
import ClockInNumpad from "@/components/shift/ClockInNumpad.vue";
import TextSelect from "@/components/global/TextSelect.vue";

export default {
  name: "ClockInDialog",
  components: {
    ClockInNumpad,
    TextSelect,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      openingCash: "0",
      cashDrawerId: null,
      availableDrawers: [],
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.openingCash = "0";
        this.cashDrawerId = null;
        this.fetchDrawers();
      }
    },
  },
  methods: {
    async fetchDrawers() {
      try {
        const { data } = await this.$http.get("cash_drawers?available_only=1");
        if (data && data.status && Array.isArray(data.data)) {
          this.availableDrawers = data.data;
        } else {
          this.availableDrawers = [];
        }
      } catch (_) {
        this.availableDrawers = [];
      }
    },
    closeDialog() {
      this.dialog = false;
    },
    async submitClockIn() {
      const openingCashAmount = Number(this.openingCash || 0);
      if (openingCashAmount < 0 || Number.isNaN(openingCashAmount)) {
        this.$toast.error(this.$t("opening_cash"));
        return;
      }

      this.loading = true;
      try {
        const payload = {
          opening_cash: openingCashAmount,
        };
        if (this.cashDrawerId) {
          payload.cash_drawer_id = this.cashDrawerId;
        }

        const { data } = await this.$http.post("clock-in", payload);

        if (data && data.status) {
          this.$toast.success(this.$t("clock_in_success"));
          this.$emit("success", data.data);
          this.dialog = false;
        } else {
          this.$toast.error(data?.message || this.$t("error_occurred"));
        }
      } catch (error) {
        this.$toast.error(error?.response?.data?.message || this.$t("error_occurred"));
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
